export function fetchJWTProviderError() {
    return {
      type: 'FETCH_JWT_PROVIDER_ERROR',
      payload: {
        ssoLoadError: true
      }
    };
}